import { Tags } from "lucide-react";
import { hasTool, cvText } from "../../lib/cvMatch";

export default function KeywordsAdded({ app, testid = "keywords-added" }) {
  const tools = new Set((app.job_tools || []).map((t) => t.toLowerCase()));
  const text = cvText(app.tailored_cv);
  const added = (app.keywords_added || []).filter((k) => !tools.has(k.toLowerCase()) || hasTool(text, k));
  if (!added.length) return null;
  return (
    <div className="gi-card p-5 sm:p-6" data-testid={testid}>
      <div className="flex items-center gap-2">
        <Tags className="w-5 h-5 text-brand" aria-hidden="true" />
        <h3 className="font-display text-lg font-bold text-ink">Keywords added for this job ({added.length})</h3>
      </div>
      <p className="text-[15px] text-body mt-1">We put these words from the job ad into your CV so ATS software matches you.</p>
      <ul className="mt-4 flex flex-wrap gap-2" data-testid={`${testid}-list`}>
        {added.map((k) => <li key={k} className="px-3 py-1 rounded-full bg-brand-soft text-brand-text text-sm font-medium">{k}</li>)}
      </ul>
    </div>
  );
}
